import React from "react";
import * as MyCells from "../../../../utils/Cells";
import * as enums from "../../../../utils/EnumMapping";
import ActionMenu from "../../../common/action/ActionMenu";
import StatusCell from "../../../common/cells/StatusCell";
import DateRangeColumnFilter, {
  DateRangeColumnFilterFn,
} from "../../../common/filters/DateRangeColumnFilter";
import StateMultiSelectColumnFilter, {
  StateMultiSelectFilterFn,
} from "../../../common/filters/StateMultiSelectColumnFilter";
import TextColumnFilter from "../../../common/filters/TextColumnFilter";

export const columns = (refresh) => {
  return [
    {
      Header: "Státusz",
      accessor: "stateLabel",
      id: "stateLabel",
      show: true,
      className: "status",
      Filter: StateMultiSelectColumnFilter,
      filter: StateMultiSelectFilterFn,
      Cell: (props) => <StatusCell row={props.row.original} />,
    },
    {
      Header: "Sorszám",
      accessor: "publicId",
      id: "publicId",
      show: true,
      className: "billNumberColumn center",
      Filter: TextColumnFilter,
    },
    {
      Header: "Csoport sorszám",
      accessor: "groupPublicId",
      id: "groupPublicId",
      show: true,
      className: "idColumn center",
      Filter: TextColumnFilter,
    },
    {
      Header: "Munkaszám",
      accessor: "nullableProjectPublicId",
      id: "nullableProjectPublicId",
      show: true,
      className: "idColumn center",
      Filter: TextColumnFilter,
    },
    {
      Header: "Helyszín",
      accessor: "location",
      id: "location",
      show: true,
      Filter: TextColumnFilter,
    },
    {
      Header: "Vevő",
      accessor: "customerName",
      id: "customerName",
      show: true,
      Filter: TextColumnFilter,
    },
    {
      Header: "Számla kelte",
      accessor: "billDate",
      id: "billDate",
      show: true,
      className: "dateColumn",
      Filter: DateRangeColumnFilter,
      filter: DateRangeColumnFilterFn,
      Cell: (props) => <MyCells.DateCell value={props.value} />,
    },
    {
      Header: "Teljesítés kelte",
      accessor: "fulfillmentDate",
      id: "fulfillmentDate",
      show: true,
      className: "dateColumn",
      Filter: DateRangeColumnFilter,
      filter: DateRangeColumnFilterFn,
      Cell: (props) => <MyCells.DateCell value={props.value} />,
    },
    {
      Header: "Fizetési határidő",
      accessor: "paymentDeadline",
      id: "paymentDeadline",
      show: true,
      className: "dateColumn",
      Filter: DateRangeColumnFilter,
      filter: DateRangeColumnFilterFn,
      Cell: (props) => <MyCells.DateCell value={props.value} />,
    },
    {
      Header: "Nettó",
      accessor: "net",
      id: "net",
      show: true,
      className: "right amountColumn",
      Filter: TextColumnFilter,
      Cell: (props) => <MyCells.NumberCell value={props.value} />,
    },
    {
      Header: "Áfa",
      accessor: "vat",
      id: "vat",
      show: true,
      className: "right amountColumn",
      Filter: TextColumnFilter,
      Cell: (props) => <MyCells.NumberCell value={props.value} />,
    },
    {
      Header: "Összeg",
      accessor: "amount",
      id: "amount",
      show: true,
      className: "right amountColumn",
      Filter: TextColumnFilter,
      Cell: (props) => <MyCells.NumberCell value={props.value} />,
    },
    {
      Header: "Hátralevő összeg",
      accessor: "remainingAmount",
      id: "remainingAmount",
      show: false,
      className: "right amountColumn",
      Filter: TextColumnFilter,
      Cell: (props) => <MyCells.NumberCell value={props.value} />,
    },
    {
      Header: "Pénznem",
      accessor: "currencyLabel",
      id: "currencyLabel",
      show: false,
      className: "idColumn center",
      Filter: TextColumnFilter,
    },
    {
      Header: "Fizetési mód",
      accessor: "paymentMethodLabel",
      id: "paymentMethodLabel",
      show: true,
      className: "iconColumn",
      Filter: StateMultiSelectColumnFilter,
      filter: StateMultiSelectFilterFn,

      Cell: (props) => (
        <MyCells.IconCell label={props.value} list={enums.paymentMethods} />
      ),
    },
    {
      Header: "Megjegyzés",
      accessor: "comment",
      id: "comment",
      show: true,
      Filter: TextColumnFilter,
    },
    {
      Header: () => null, // No header
      id: "menu",
      show: true,
      headerClassName: "actions",
      className: "actions",
      Cell: (value) => (
        <ActionMenu
          row={value.row.original}
          tabletype={"outgoingbill"}
          refresh={refresh}
        />
      ),
    },
  ];
};
